import Logo from "shared/Logo/Logo";
import { CustomLink } from "data/types";
import React from "react";
import { Link } from "react-router-dom";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "1",
    title: "Explore",
    menus: [
      { href: "/categories", label: "Categories" },
      { href: "/projects", label: "Projects" },
      { href: "/clints", label: "Clients" },
      { href: "/blog", label: "Blogs" },
    ],
  },
  {
    id: "2",
    title: "Contact Us",
    menus: [
      { href: "mailto:bcrltduk@gmail.com", label: "bcrltduk@gmail.com" },
      { href: "tel:+97167421322", label: "+971 6 7421322" },
      { href: "tel:+971506454326", label: "+971506454326" },
    ],
  },
  {
    id: "3",
    title: "Company",
    menus: [
      { href: "/about", label: "About Us" },
      { href: "/contact", label: "Contact Us" },
      { href: "/downloads", label: "Downloads" },
    ],
  },
];

const Footer: React.FC = () => {
  const renderFooterLink = (item: CustomLink) => {
    const isExternal =
      item.href.startsWith("mailto:") ||
      item.href.startsWith("tel:") ||
      item.href.startsWith("http");

    if (isExternal) {
      return (
        <a
          href={item.href}
          className="text-sm text-white/65 hover:text-white transition-colors break-all leading-relaxed"
        >
          {item.label}
        </a>
      );
    }

    return (
      <Link
        to={item.href}
        className="text-sm text-white/65 hover:text-white transition-colors break-words leading-relaxed"
      >
        {item.label}
      </Link>
    );
  };

  return (
    <footer className="nc-Footer relative bg-[#0a1628] text-white border-t border-white/10">
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_20%_10%,rgba(59,130,246,0.12),transparent_30%),radial-gradient(circle_at_80%_90%,rgba(244,63,94,0.1),transparent_35%)]" />

      <div className="container relative px-4 sm:px-6 py-12 sm:py-16 lg:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8 lg:gap-10">
          <div className="min-w-0 sm:col-span-2 lg:col-span-5">
            <Logo className="w-20 sm:w-24" isDark />
            <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-md">
              BCR Ltd. UK — leading supplier of expansion joint covers, tile
              trims, shadow gap profiles, and premium building solutions across
              the UAE and GCC.
            </p>

            <div className="mt-6 flex items-center gap-2.5 flex-wrap">
              {[
                {
                  href: "https://www.facebook.com/people/BCR-Ltd-Expansion-Joint-UK/100064174416066/",
                  icon: "lab la-facebook-square",
                  label: "Facebook",
                },
                {
                  href: "https://www.instagram.com/bcr_profiles/",
                  icon: "lab la-instagram",
                  label: "Instagram",
                },
                {
                  href: "https://www.youtube.com/channel/UC37h6R6_AODVk5hbxZ86-qQ",
                  icon: "lab la-youtube",
                  label: "YouTube",
                },
                {
                  href: "https://www.linkedin.com/company/shadow-gap-profiles/",
                  icon: "lab la-linkedin-in",
                  label: "LinkedIn",
                },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 rounded-full border border-white/15 bg-white/5 hover:bg-white/10 hover:border-white/30 text-white/80 hover:text-white transition-all flex items-center justify-center"
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          {widgetMenus.map((menu) => (
            <div
              key={menu.id}
              className={`min-w-0 ${
                menu.id === "1"
                  ? "lg:col-span-2"
                  : menu.id === "2"
                  ? "lg:col-span-3"
                  : "lg:col-span-2"
              }`}
            >
              <h2 className="font-semibold text-white text-base mb-4 tracking-wide">
                {menu.title}
              </h2>
              <ul className="space-y-2.5">
                {menu.menus.map((item, idx) => (
                  <li key={idx}>{renderFooterLink(item)}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
          <p className="text-sm text-white/50 text-center lg:text-left">
            © {new Date().getFullYear()} BCR Ltd. UK. All rights reserved.
          </p>
          <p className="text-sm text-white/40 text-center lg:text-right">
            UK Quality · UAE Stock
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
